module.exports = __webpack_public_path__ + "fonts/opensans-light.464f89f1.woff2";